<a class="back" [routerLink]="'/'"><span [ghs-label]="'tools.backToGhs'"></span></a>

<div class="edition-editor">
    <h1><span [ghs-label]="'editor.edition'"></span> (<span [ghs-label]="'wip'"></span>)</h1>
    <div class="columns">
        <div class="input">
            <div class="edition-base">
                <h2><span [ghs-label]="'editor.edition.base'"></span></h2>

                <div class="base-data dialog">
                    <div class="dialog-container">
                        <label><span [ghs-label]="'editor.edition.edition'"></span></label>
                        <input [(ngModel)]="editionData.edition" [ghs-label]="'editor.edition.edition'"
                            [ghs-label-attribute]="'placeholder'" (change)="editionDataToJson()"
                            (keyup)="editionDataToJson()">

                        <label><span [ghs-label]="'editor.edition.extensions'"></span></label>
                        <select [(ngModel)]="editionData.extensions" multiple (change)="editionDataToJson()">
                            <option [value]="editionData.edition" *ngFor="let editionData of gameManager.editionData;">
                                <span [ghs-label]="'data.edition.' + editionData.edition"></span>
                                [{{editionData.edition}}]
                            </option>
                        </select>

                        <label><span [ghs-label]="'editor.edition.conditions'"></span></label>

                        <div class="conditions">
                            <a (click)="toggleAllConditions(conditionSelect)">
                                <span [ghs-label]="(editionData.conditions.length != Conditions.length ?
                            'editor.edition.conditions.allSelected': 'editor.edition.conditions.allHint')"></span>
                            </a>
                            <select #conditionSelect [(ngModel)]="editionData.conditions" multiple
                                (change)="editionDataToJson()">
                                <option [value]="condition" *ngFor="let condition of Conditions;">
                                    <span [ghs-label]="'game.condition.' + condition" [ghs-label-args]="['X']"></span>
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="files">

                <h2><span [ghs-label]="'editor.edition.character'"></span></h2>

                <div class="file-list characters">
                    <span class="file" [ghs-label]="'editor.edition.character.remove'" [ghs-label-attribute]="'title'"
                        *ngFor="let characterData of editionData.characters; let index = index;"
                        (click)="removeCharacter(index)">
                        <span [ghs-label]="'data.character.' + characterData.edition + '.' + characterData.name"></span>
                        [{{characterData.name}}]</span>
                </div>

                <input type="file" multiple accept="application/json" (change)="addCharacterJson($event)">
            </div>

            <div class="files">

                <h2><span [ghs-label]="'editor.edition.monster'"></span></h2>

                <div class="file-list monsters">
                    <span class="file" [ghs-label]="'editor.edition.monster.remove'" [ghs-label-attribute]="'title'"
                        *ngFor="let monsterData of editionData.monsters; let index = index;"
                        (click)="removeMonster(index)">
                        <span [ghs-label]="'data.monster.' + monsterData.name"></span>
                        [{{monsterData.name}}]</span>
                </div>

                <input type="file" multiple accept="application/json" (change)="addMonsterJson($event)">
            </div>

            <div class="files">

                <h2><span [ghs-label]="'editor.edition.decks'"></span></h2>

                <div class="file-list decks">
                    <span class="file" [ghs-label]="'editor.edition.decks.remove'" [ghs-label-attribute]="'title'"
                        *ngFor="let deckData of editionData.decks; let index = index;" (click)="removeDeck(index)">
                        <span [ghs-label]="'data.deck.' + deckData.name"></span>
                        [{{deckData.name}}]</span>
                </div>

                <input type="file" multiple accept="application/json" (change)="addDeckJson($event)">
            </div>
        </div>
        <div class="output">
            <h2><span [ghs-label]="'editor.edition.json'"></span>

                <select (change)="loadEditionData($event)">
                    <option [value]="-1">&lt;<span [ghs-label]="'editor.edition.new'"></span>&gt;</option>
                    <option [value]="index" *ngFor="let editionData of gameManager.editionData; let index = index;">
                        <span [ghs-label]="'data.edition.' + editionData.edition"></span> [{{editionData.edition}}]
                    </option>
                </select>

            </h2>

            <div> {{editionError}} </div>
            <textarea #inputEditionData></textarea>

            <a class="button" [href]="'data:application/json;charset=utf-8,' + jsonDownload()"
                [download]="editionData.edition + '.json'"><img class="ghs-icon" src="./assets/images/export.svg">
                <span [ghs-label]="'editor.edition.json.download'"></span></a>
        </div>
    </div>
</div>